import IntegrateApi from 'components/organisms/IntegrateApi';

const apiData = {
  key: 'API',
  renderAction: (data, refetch) => {
    return <IntegrateApi selectedIntegration={data} {...{ refetch }} />;
  }
};

export default apiData;
